import useIsMounted from 'src/react/helpers/use_is_mounted';
import { useState } from 'react';

const useActionWithDisabled = () => {
  const isMounted = useIsMounted();
  const [isDisabled, setIsDisabled] = useState(false);
  const setDisabledIfMounted = (disabled) => {
    if (isMounted.current) {
      setIsDisabled(disabled);
    }
  };

  const wrapAction = (callback, ...args) => async () => {
    try {
      setDisabledIfMounted(true);
      // eslint-disable-next-line callback-return
      await callback(...args);
      setDisabledIfMounted(false);
    } catch (e) {
      setDisabledIfMounted(false);
    }
  };

  return {
    wrapAction,
    isDisabled,
    setIsDisabled
  };
};

export default useActionWithDisabled;
